import { ContentWithAside } from "layouts/kiosk-h"

import { themeOptionFactories } from "./theme"
import { EmServiceAndTouristMobilePage } from "./pages/em-service-and-tourist"
import { EmServiceAndTouristKioskHPage } from "./pages/em-service-and-tourist/index.kiosk"

export const emServiceAndTourist = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "service-and-tourist",
        element: <EmServiceAndTouristMobilePage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "service-and-tourist",
        element: <EmServiceAndTouristKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
